import i18n from 'i18n';
import { validatePaymentInfo, validatePaymentInfoForBanner } from 'commonComponents/paymentInformation/PaymentInformation.util';
import { INIT_TIME } from './ManagePaymentOptions.constants';

export const getLastDateOfMonth = (month, year) => {
  const date = new Date(year, month, 0);
  const formattedLastDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return formattedLastDate;
};

export const getMonthYear = (date) => {
  const currentDate = new Date();
  const providedDate = date ? new Date(date) : new Date(currentDate.getFullYear(), currentDate.getMonth() + 1);
  return `${providedDate.toLocaleString('default', { month: 'long' })} ${providedDate.getFullYear()}`;
};

export const getNextMonthsList = (noOfMonths = 12) => {
  const monthsList = [];
  const currentDate = new Date();

  for (let i = 0; i < noOfMonths; i += 1) {
    const monthYear = new Date(currentDate.getFullYear(), currentDate.getMonth() + i + 1);
    monthsList.push({
      id: i,
      description: monthYear.toLocaleString('default', { month: 'long', year: 'numeric' }),
      dateTime: `${getLastDateOfMonth(monthYear.getMonth() + 1, monthYear.getFullYear())} ${INIT_TIME}`,
    });
  }

  return monthsList;
};

export const getPaymentInfoValidationErrors = (paymentInfo, ccConsent, transientTokenData) => {
  const { t } = i18n;
  const paymentValidationErrors = validatePaymentInfo(paymentInfo, t, transientTokenData);
  if (!transientTokenData.transientToken) {
    paymentValidationErrors.cardNumber = t('payment_information__card_validation');
    paymentValidationErrors.isError = true;
  }

  return paymentValidationErrors;
};

export const getPaymentInfoValidationErrorsForBanner = (paymentInfo, ccConsent, transientToken) => {
  const { t } = i18n;

  const paymentValidationErrorsForBanner = validatePaymentInfoForBanner(paymentInfo, t);

  if (!transientToken) {
    paymentValidationErrorsForBanner.cardNumber = t('payment_information__card_validation');
    paymentValidationErrorsForBanner.isError = true;
  }

  return paymentValidationErrorsForBanner;
};
